import React, { useCallback, useEffect, useRef, useState } from 'react';
import ExpireNotice from './ExpireNotice';
var INIT_TIME = 30 * 60; // 倒數的初始秒數（30 分鐘）
// 依到期時間戳計算剩餘秒數，避免分頁被瀏覽器節流時倒數失準
var getTimeLeft = function (expireAt) {
    return Math.max(0, Math.ceil((expireAt - Date.now()) / 1000));
};
var ConnectionTime = function () {
    var expireAtRef = useRef(Date.now() + INIT_TIME * 1000); // 到期時間戳
    var _a = useState(INIT_TIME), timeLeft = _a[0], setTimeLeft = _a[1];
    var _b = useState(false), openNotice = _b[0], setOpenNotice = _b[1];
    var expired = timeLeft === 0;
    // 重置倒數：往後推一個完整時間
    var resetTimer = useCallback(function () {
        expireAtRef.current = Date.now() + INIT_TIME * 1000;
        setTimeLeft(INIT_TIME);
    }, []);
    useEffect(function () {
        var timer = window.setInterval(function () {
            setTimeLeft(getTimeLeft(expireAtRef.current));
        }, 1000);
        return function () { return clearInterval(timer); };
    }, []);
    // 倒數歸零跳出逾時提示
    useEffect(function () {
        if (expired)
            setOpenNotice(true);
    }, [expired]);
    // 偵測使用者操作（滑鼠點擊、螢幕觸控）就重新計時，已逾時則不再重置
    useEffect(function () {
        if (expired)
            return undefined;
        var events = ['click', 'touchstart'];
        events.forEach(function (e) { return window.addEventListener(e, resetTimer); });
        return function () {
            return events.forEach(function (e) { return window.removeEventListener(e, resetTimer); });
        };
    }, [expired, resetTimer]);
    var minutes = String(Math.floor(timeLeft / 60)).padStart(2, '0');
    var seconds = String(timeLeft % 60).padStart(2, '0');
    return (React.createElement(React.Fragment, null,
        React.createElement(ExpireNotice, { open: openNotice, onClose: function () { return setOpenNotice(false); }, resetTimer: resetTimer }),
        React.createElement("li", { className: "no-line d-none d-lg-block" },
            React.createElement("button", { type: "button", className: "nav-link border-0 bg-transparent p-0", title: "\u9023\u7DDA\u5269\u9918\u6642\u9593", id: "resetTimerBtn", "aria-label": "\u9023\u7DDA\u5269\u9918\u6642\u9593" },
                React.createElement("i", { className: "icon-clock1 d-flex", "aria-hidden": "true" }),
                "\u9023\u7DDA\u5269\u9918\u6642\u9593\uFF1A",
                React.createElement("span", { className: "text-warning countdown-text" },
                    minutes,
                    ":",
                    seconds),
                React.createElement("i", { className: "icon-redo", role: "button", tabIndex: 0, onClick: resetTimer, onKeyDown: function (e) {
                        if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            resetTimer();
                        }
                    }, "aria-label": "\u91CD\u7F6E\u9023\u7DDA\u6642\u9593", style: { cursor: 'pointer' } })))));
};
export default ConnectionTime;
